module.exports = __webpack_public_path__ + "img/avatar3.438ba1f4.png";